import React, { useCallback } from "react";
import { connect } from "react-redux";

import { EntityType } from "@mapmycustomers/shared/enum";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import ColumnPane from "@app/component/SelectColumnsPane/ColumnPane";
import { updateIntegrationSyncsViewState } from "@app/store/integrations/actions";
import { getIntegrationViewState } from "@app/store/integrations/selectors";
import { RootState } from "@app/store/rootReducer";
import ColumnVisibility from "@app/types/viewModel/ColumnVisibility";
import IntegrationViewState from "@app/types/viewModel/IntegrationSyncsViewState";

interface Props {
  fieldFilter?: (field: IField) => boolean;
  onHide: () => void;
  updateIntegrationViewState: typeof updateIntegrationSyncsViewState.request;
  viewState: IntegrationViewState;
  visible: boolean;
}

const SelectColumnsPane: React.FC<Props> = ({
  fieldFilter,
  onHide,
  updateIntegrationViewState,
  viewState,
  visible,
}) => {
  const handleUpdate = useCallback(
    (visibilities: ColumnVisibility[]) => {
      const fieldNameToVisibility = new Map(visibilities.map((v) => [v.field.name, v.visible]));
      const updatedColumns = viewState.columns.map((column) => ({
        ...column,
        visible:
          column.field.hasFeature(FieldFeature.ALWAYS_VISIBLE) ||
          (fieldNameToVisibility.get(column.field.name) ?? column.visible),
      }));
      updateIntegrationViewState({ viewState: { columns: updatedColumns } });
    },
    [updateIntegrationViewState, viewState.columns]
  );

  return (
    <ColumnPane
      columns={viewState.columns}
      entityType={EntityType.INTEGRATION}
      fieldFilter={fieldFilter}
      onHide={onHide}
      onUpdate={handleUpdate}
      showCategories={false}
      visible={visible}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  viewState: getIntegrationViewState(state),
});

const mapDispatchToProps = {
  updateIntegrationViewState: updateIntegrationSyncsViewState.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectColumnsPane);
